
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/enroll",
      function () {
        return require("private-next-pages/[lang]/enroll.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/enroll"])
      });
    }
  